<template>
  <a-spin :spinning="confirmLoading">
    <a-form :form="form" autocomplete="off">
      <!-- 账户 -->
      <mtc-form-item label="label.userAccount" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input :placeholder="$t('label.pleaseEnterAccount')"
                 autocomplete="off"
                 v-decorator.trim="['username', validatorRules.username]"
                 :readOnly="!!model.id" />
      </mtc-form-item>
      <!-- 密码 -->
      <mtc-form-item label="label.loginPassword" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-password auto-complete="off"
                          :placeholder="$t('label.pleaseEnterLoginPassword')"
                          v-decorator="['password', validatorRules.password]" />
      </mtc-form-item>
      <!-- 确认密码 -->
      <mtc-form-item :label="$t('label.confirmPassword')" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-password autocomplete="off"
                          @blur="handleConfirmBlur"
                          :placeholder="$t('label.pleaseConfirmLoginPassword')"
                          v-decorator="['confirmpassword', validatorRules.confirmpassword]" />
      </mtc-form-item>
      <!-- 手机号 -->
      <mtc-form-item label="label.cellPhone" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input :placeholder="$t('label.pleaseEnterYourCellPhone')"
                 allowClear
                 :maxLength="11"
                 v-decorator="['phone', validatorRules.phone]" />
      </mtc-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import langInputMixin from '@/mixins/langInputMixin'
import { duplicateCheck } from '@api/api'
import { setLangInputParams } from '@/utils/langUtils'
import { mapGetters } from 'vuex'

export default {
  name: 'UserForm',
  title: '新建用户基本信息',
  mixins: [mtcLangModalMixin, langInputMixin],
  data() {
    return {
      // 表名
      mainTable: 'sys_user',
      confirmDirty: false,
      // 校验规则
      validatorRules: {
        username: {
          rules: [
            {
              required: true,
              message: this.$t('label.pleaseEnterAccount')
            },
            {
              validator: this.validateUsername
            }]
        },
        password: {
          rules: [
            {
              required: true
              // pattern:/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/,
              // message: '密码由8位数字、大小写字母和特殊符号组成!'
            },
            { validator: this.validateToNextPassword }
          ]
        },
        confirmpassword: {
          rules: [
            {
              required: true,
              message: this.$t('label.pleaseConfirmLoginPassword')
            },
            { validator: this.compareToFirstPassword }
          ]
        },
        realname: { rules: [{ required: true, message: this.$t('label.pleaseEnterUsername') }] },
        phone: {
          rules: [
            { validator: this.validatePhone, trigger: 'blur' },
            { required: true, message: this.$t('label.pleaseEnterCellPhoneNumber') }]
        }
      }
    }
  },
  computed: {
    ...mapGetters(['langFieldMap'])
  },
  methods: {
    submitForm() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = Object.assign(this.model, values)
          formData.userIdentity = this.identity
          // 设置数据多语言参数
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          this.$emit('ok', formData)
        }
      })
    },
    // 手机号校验
    async validatePhone(rule, value, callback) {
      if (!value) {
        callback()
      } else {
        if (new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)) {
          let res = await this.checkPhone(value)
          res.success? callback(): callback('手机号已存在')
        } else {
          callback('请输入正确格式的手机号码')
        }
      }
    },
    // 确认密码校验
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback('两次输入的密码不一样')
      } else {
        callback()
      }
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    // 接口校验手机号
    async checkPhone(fieldVal) {
      let params = {
        tableName: 'sys_user',
        fieldName: 'phone',
        fieldVal
      }
      return duplicateCheck(params)
    }
  }
}
</script>